"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("../../styles/components/_footer.scss");
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.subscribe = function () {
            window.open("https://tinyletter.com/ashishdotme", 'popupwindow', 'scrollbars=yes,width=800,height=600');
            return true;
        };
        return _this;
    }
    Footer.prototype.render = function () {
        return (react_1.default.createElement("footer", { className: 'footer' },
            react_1.default.createElement("div", { className: 'container', style: { color: '#fefefe' } },
                react_1.default.createElement("div", { className: 'columns' },
                    react_1.default.createElement("div", { className: 'column' },
                        react_1.default.createElement("img", { src: 'https://ashish.me/assets/img/logo.png', alt: 'ashish.me', height: '100', width: '100', style: { margin: '10px' } }),
                        react_1.default.createElement("p", { className: 'title is-4', style: { color: 'white' } },
                            ' ',
                            "ashish.me")),
                    react_1.default.createElement("div", { className: 'column' },
                        react_1.default.createElement("b", null,
                            react_1.default.createElement("p", { style: {
                                    borderBottom: '2px solid white',
                                    marginBottom: '15px',
                                } }, "LINKS")),
                        react_1.default.createElement("ul", null,
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: 'https://ashish.me' }, "Home")),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: 'https://ashish.me/blog' }, "Blog")),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: 'https://notes.ashish.me' }, "Notes")),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: 'https://movies.ashish.me' }, "Movies")),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: 'https://shows.ashish.me' }, "Shows")),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: 'https://courses.ashish.me' }, "Courses")),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: 'https://ashish.me/contact' }, "Contact")))),
                    react_1.default.createElement("div", { className: 'column' },
                        react_1.default.createElement("b", null,
                            react_1.default.createElement("p", { style: {
                                    borderBottom: '2px solid white',
                                    marginBottom: '15px',
                                } }, "FOLLOW")),
                        react_1.default.createElement("ul", null,
                            react_1.default.createElement("li", null,
                                ' ',
                                react_1.default.createElement("a", { href: 'https://linkedin.com/in/ashishdotme' }, "Linkedin")),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: 'https://twitter.com/ashishdotme' }, "Twitter")),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: 'https://facebook.com/ashishdotme' }, "Facebook")),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: 'https://github.com/ashishdotme' }, "Github")),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: 'https://instagram.com/ashishdotme' }, "Instagram")))),
                    react_1.default.createElement("div", { className: 'column is-one-third' },
                        react_1.default.createElement("b", null,
                            react_1.default.createElement("p", { style: {
                                    borderBottom: '2px solid white',
                                    marginBottom: '15px',
                                } }, "UPDATES")),
                        react_1.default.createElement("form", { name: 'subscribe', action: 'https://tinyletter.com/ashishdotme', method: 'post', target: 'popupwindow', onSubmit: this.subscribe },
                            react_1.default.createElement("div", { className: 'field has-addons' },
                                react_1.default.createElement("p", { className: 'control' },
                                    react_1.default.createElement("input", { className: 'input', type: 'text', placeholder: 'Email address', name: 'email' })),
                                react_1.default.createElement("p", { className: 'control' },
                                    react_1.default.createElement("input", { className: 'button is-primary', type: 'submit', value: 'Subscribe' })))))),
                react_1.default.createElement("br", null),
                react_1.default.createElement("div", { className: 'columns' },
                    react_1.default.createElement("div", { className: 'column has-text-centered' },
                        react_1.default.createElement("p", null,
                            "\u00A9 ",
                            new Date().getFullYear(),
                            " Ashish Patel."))))));
    };
    return Footer;
}(react_1.PureComponent));
exports.default = Footer;
//# sourceMappingURL=footer.js.map